import { Modal } from "ant-design-vue";

export const errorInfoDis = async (msg: string) => {
  if (
    msg?.indexOf("WebAssembly.instantiateStreaming(): invalid") > -1 ||
    msg?.indexOf("WebAssembly.instantiate(): invalid") > -1
  ) {
    Modal.destroyAll();
    Modal.error({
      title: "错误信息提示",
      content: `您当前浏览器版本过低，请更新至最新版本或更换浏览器`,
    });
    return;
  }
  Modal.destroyAll();
  Modal.error({
    title: "错误信息提示",
    content: `${msg}`,
  });
};
